module.exports = __webpack_public_path__ + "static/media/mail.54b8aff5.webp";